export default "__VITE_ASSET__Dj7auu6Z__ 400w, __VITE_ASSET__CoyWMF0j__ 800w, __VITE_ASSET__ClEDZMzb__ 1024w";